<template>
  <section class="pay-success vh100">
    <div class="success-content">
      <div class="content-hint">
        <div class="hint-icon">
          <span class="iconfont icon-result_header_right"></span>
        </div>
        <div class="hint-text">购买成功</div>
      </div>
      <div class="content-way">
        <div class="way-title">学习方式</div>
        <div class="way-text">
          <p>· 在已购课程中即可进行学习 ·</p>
          <p>
            · 关注
            <span>{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '微课系统'}}</span>公众号即可进行学习 ·
          </p>
        </div>
      </div>
      <div class="content-detail">
        <p class="detail-name">课程名称</p>
        <p class="detail-title">{{queryInfo.title}}</p>
        <p class="detail-date">课程有效期：{{!queryInfo.validDays || queryInfo.validDays == '' || queryInfo.validDays == null ? '永久有效' : `${queryInfo.validDays}天`}}</p>
      </div>
      <div class="content-btn" @click="jumpSchedule">
        <span>立即学习</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      queryInfo: {}
    }
  },

  mounted () {
    this.queryInfo = this.$store.state.signUpCourseInfo
  },

  methods: {
    jumpSchedule () {
      if (this.queryInfo.courseType === 8) {
        // 跳转扫描二维码
        this.$router.push('wx-service')
      } else {
        // 跳转目录
        this.$router.push(`/schedule?courseId=${this.queryInfo.courseId}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../style/main";
.pay-success {
  padding: rem(36);
  background: rgba(242, 243, 244, 1);
  box-sizing: border-box;
  .success-content {
    background: #fff;
    box-shadow: 0px 3px 43px 0px rgba(189, 201, 209, 0.1);
    border-radius: rem(14);
    height: 100%;
    .content-hint {
      padding-top: rem(50);
      text-align: center;

      .hint-icon {
        span {
          display: inline-block;
          background: $globalColor;
          color: #fff;
          font-size: rem(120);
          border-radius: 50%;
        }
      }

      .hint-text {
        margin-top: rem(20);
        font-size: rem(39);
        color: #2c2c2c;
        font-weight: bold;
      }
    }

    .content-way {
      position: relative;
      margin: 0 rem(18);
      margin-top: rem(68);
      padding: rem(62) 0 rem(41);
      background: rgba(248, 248, 248, 1);
      box-shadow: 0px 3px rem(43) 0px rgba(189, 201, 209, 0.1);
      border-radius: rem(14);

      .way-title {
        position: absolute;
        left: 0;
        right: 0;
        top: rem(-29);
        width: rem(219);
        line-height: rem(58);
        text-align: center;
        color: #fff;
        font-size: rem(30);
        background: rgba(218, 204, 190, 1);
        border-radius: rem(28);
        margin: auto;
      }

      .way-text {
        text-align: center;
        p {
          line-height: rem(42);
          color: #999;
          font-size: rem(30);
          span {
            color: $globalColor;
          }
        }
      }
    }

    .content-detail {
      text-align: center;
      margin-top: rem(51);
      .detail-name {
        font-size: rem(34);
        color: $globalColor;
        font-weight: bold;
      }

      .detail-title {
        margin-top: rem(20);
        font-size: rem(30);
        color: #333;
      }

      .detail-date {
        margin-top: rem(30);
        color: #999;
        font-size: rem(27);
      }
    }

    .content-btn {
      margin-top: rem(71);
      text-align: center;

      span {
        display: inline-block;
        width: rem(344);
        height: rem(70);
        line-height: rem(70);
        background: $globalColor;
        border-radius: rem(33);
        color: #fff;
        cursor: pointer;
        font-weight: bold;
        font-size: rem(36);
      }
    }
  }
}
</style>
